<template>
	<div class="footer">
    <div class="footer_top">
      <div class="footer_hotline">
        <div class="hotline_text">
          <span class="hotline_label">全国统一服务热线</span>
          <span class="hotline_time">服务时间：8:00-21:00</span>
        </div>
        <div class="sep-line-v"></div>
        <a class="hotline_num" href="tel:400-900-6896">400-900-6896</a>
      </div>
    </div>
		<div class="footer_bottom">
      <p class="footer_about">
        <router-link v-for="item in data.aboutItem" :key="item" :to="item.link">{{ item.name }}</router-link>
      </p>
      <div class="footer_meta">
        <p>版权所有：北京中盛佳源教育科技有限公司</p>
        <span class="meta-divider"></span>
        <p class="footer_link">
          <a href="http://beian.miit.gov.cn">京ICP备15052609号-2</a>
        </p>
        <span class="meta-divider"></span>
        <p class="footer_power">
          <img src="https://img.alicdn.com/tfs/TB13DzOjXP7gK0jSZFjXXc5aXXa-212-48.png">
          提供计算与安全服务
        </p>
      </div>
    </div>
	</div>
</template>

<script lang="ts" setup>
import {reactive} from 'vue';

const data: any = reactive({
	aboutItem: [
		{
			'name': '加入我们',
			'link': '/666',
		},
		{
			'name': '关于我们',
			'link': '/777',
		},
		{
			'name': '联系我们',
			'link': '/888',
		},
	],
});
</script>
<style scoped lang="scss">
.footer {
	text-align: center;

	min-width: 1024px;
	box-sizing: border-box;

	p {
		margin: 0;
		font-size: 14px;
		line-height: 1.5;
	}

	.footer_about {
		display: none;
	}

	.footer_top {
		padding: 36px 0;
		background: #f9f9f9;
		border-bottom: 1px solid #ececec;
	}

	.footer_hotline {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 24px;

		.hotline_text {
			display: flex;
			flex-direction: column;
			align-items: flex-start;

			.hotline_label {
				color: #888;
				font-size: 14px;
				line-height: 1.6;
			}

			.hotline_time {
				color: #b0b0b0;
				font-size: 13px;
				line-height: 1.6;
			}
		}

		.sep-line-v {
			width: 1px;
			height: 40px;
			background: #dcdcdc;
		}

		.hotline_num {
			color: #4490ed;
			font-size: 38px;
			font-weight: 600;
			letter-spacing: 1px;
			font-family: "Microsoft YaHei", Arial, sans-serif;
			transition: color 0.2s ease;

			&:hover {
				color: #2a7ae0;
			}
		}
	}

	.footer_bottom {
		padding: 22px 0;
		background-color: rgb(68, 142, 237);
	}

	.footer_meta {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-wrap: wrap;
		gap: 14px;

		p {
			color: rgba(255, 255, 255, 0.85);

			a {
				color: rgba(255, 255, 255, 0.85);
				transition: color 0.2s ease;

				&:hover {
					color: #fff;
					text-decoration: underline;
				}
			}
		}

		.meta-divider {
			width: 1px;
			height: 12px;
			background: rgba(255, 255, 255, 0.4);
		}

		.footer_power {
			display: flex;
			align-items: center;

			img {
				width: 70px;
				margin-right: 8px;
			}
		}
	}
}

</style>